import { APIServiceType } from '@/api/types';
import { DdEventCategory, DdEventType } from '@/utilities/logger/datadog/types';
import { ErrorType } from './types';

export class CustomError extends Error {
  meta?: {
    context?: Record<string, unknown>;
    eventType?: DdEventType;
    reason?: string;
    service?: APIServiceType;
    stack?: string;
    type: ErrorType;
    useCase?: DdEventCategory;
  };

  constructor(
    message: string,
    meta?: {
      context?: Record<string, unknown>;
      eventType?: DdEventType;
      reason?: string;
      service?: APIServiceType;
      stack?: string;
      type: ErrorType;
      useCase?: DdEventCategory;
    },
  ) {
    super(message);
    this.name = 'CustomError';
    this.meta = meta;
  }
}
